import {useQuery} from "@apollo/client";
import {useState} from "react";

import {Sorting, SortingDirection} from "@/components/table/Table.types.ts";
import {usePagination} from "@/lib/hooks/usePagination.ts";
import {GQL_INVOICES_LIST, InvoicesListResponse} from "@/lib/queries/billing.ts";
import {InvoicesNotice} from "@/pages/billing/invoices/InvoicesNotice.tsx";
import {InvoicesTable} from "@/pages/billing/invoices/InvoicesTable.tsx";

export const InvoicesList = () => {
  const {pagination, setPagination} = usePagination();
  const [sorting, setSorting] = useState<Sorting>({column: "created_at", direction: SortingDirection.Desc});

  const {data} = useQuery<InvoicesListResponse>(GQL_INVOICES_LIST, {
    variables: {
      sort: sorting.direction == SortingDirection.Asc ? sorting.column : `-${sorting.column}`,
      ...pagination,
    },
  });
  return (
    <>
      <div className="mb-4">
        <InvoicesNotice />
      </div>
      {data?.invoicesList.items && data.invoicesList.items.length > 0 ? (
        <InvoicesTable
          items={data?.invoicesList.items || []}
          sorting={sorting}
          onSetSorting={setSorting}
          pagination={pagination}
          updatePagination={setPagination}
          totalRows={data?.invoicesList?.total || 0}
        />
      ) : null}
    </>
  );
};
